module.exports = __webpack_public_path__ + "static/media/preview_stamp_campaign_details_page_task_startted_name.40b6351f.svg";